module.exports = __webpack_public_path__ + "static/media/partnerImg2.81dbf358.webp";